import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pages/quiz")({
  beforeLoad: () => {
    throw redirect({
      to: "/products/$slug",
      params: { slug: "chapter-vials" },
      statusCode: 301,
    });
  },
});
